import { otherApiClient } from ".";
import { toQueryStringCamel } from "../utils/misc";
export const ActionType = {
    view3minute: "view_3minute",
    print: "print",
    download: "download"
};
export const ItemType = {
    handout: "handout",
    studio: "studioHandout"
};
export var PassCategory;
(function(PassCategory) {
    PassCategory["Solvookplus"] = "solvookplus";
    PassCategory["Ticket"] = "ticket";
    PassCategory["Subscription"] = "solvookplus-subscribe";
    PassCategory["Expert"] = "expert";
    PassCategory["ExpertSubscription"] = "expert-subscribe";
    PassCategory["Package"] = "package";
    PassCategory["FreePass"] = "freepass";
    PassCategory["Cash"] = "cash";
})(PassCategory || (PassCategory = {}));
// 마이쏠북 이용권 관리 페이지 뱃지 라벨 매핑
// 구독/쏠북플러스 계열은 서비스 종료 방향 → 매핑 대상에서 제외
export const PassCategoryWithString = {
    ["expert"]: "엑스퍼트",
    ["freepass"]: "프리패스",
    ["ticket"]: "자료 이용권"
};
// 표시용 라벨 매핑 (mixpanel `Tab Name` 등). SubjectsWithString에는 GRADE 키가 없어
// 그대로 쓰면 undefined가 전송되므로 별도 정의한다.
export const GRADE_LABEL = {
    GRADE1: "고1",
    GRADE23: "고2∙3"
};
// 학년 탭 → `/main/products` 의 displayGrade 쿼리 값. 메인 상품 조회 파라미터로 쓴다 (usePassTab 참고).
// GRADE_LABEL과 문자가 다르다: 라벨은 '고2∙3'(U+2219)이지만 BE는 '고2·3'(U+00B7)만 매칭한다 — U+2219로 보내면 0건.
export const DISPLAY_GRADE_PARAM = {
    GRADE1: "고1",
    GRADE23: "고2\xb73"
};
// 탭 값 → 비교용 숫자 키
const GRADE_TAB_DIGITS = {
    GRADE1: "1",
    GRADE23: "23"
};
export const isValidPassGrade = (value)=>value === "GRADE1" || value === "GRADE23";
// '고1'/'고2·3'/'고2∙3' 등 구분자 표기가 달라도 숫자만 남겨 비교한다. '고1'→'1', '고2·3'→'23'
export const normalizeGradeDigits = (raw)=>(raw !== null && raw !== void 0 ? raw : "").replace(/[^0-9]/g, "");
// 사용자 프로필 학년(schoolGrade: '10' | '20' | '30') + 학교급(education) → 학생 이용권 학년 탭.
// 탭은 고1 / 고2·3 두 개뿐이라 학교급이 확실하면 학년 숫자보다 학교급이 우선한다.
// - 중학생: 학년과 무관하게 고1 (중2·중3이 고2·3으로 가면 안 된다)
// - 대학생: 학년과 무관하게 고2·3 (학년 자체를 설정하지 않아 폴백에 맡기면 고1로 떨어진다)
// - 고등학생: 1학년 → GRADE1, 2·3학년 → GRADE23
// 학년이 없거나 예상 밖이면 null (호출부에서 기본값 처리).
// 학교급이 null 인 경우(BE 정규값·가입 직후 등)는 폴백해 학년으로만 판정한다 —
// 'high' 를 기준으로 분기하면 이 구간에서 고2·3 학생이 전부 고1 로 떨어진다.
export const passGradeFromSchoolGrade = (schoolGrade, schoolLevel)=>{
    if (schoolLevel === "middle") return "GRADE1";
    if (schoolLevel === "univ") return "GRADE23";
    switch(normalizeGradeDigits(schoolGrade == null ? null : String(schoolGrade))){
        case "10":
            return "GRADE1";
        case "20":
        case "30":
            return "GRADE23";
        default:
            return null;
    }
};
// 이용권 리스트 아이템의 grade가 선택 학년 탭에 매칭되는지 판정. 누락이면 '학년 무관'으로 보고 모든 탭에 노출.
export const matchesPassGrade = (itemGrade, tab)=>{
    const digits = normalizeGradeDigits(itemGrade);
    if (!digits) return true;
    return digits === GRADE_TAB_DIGITS[tab];
};
export const ExpiredReasonWithString = {
    COUNT: "사용횟수 소진",
    AMOUNT: "포인트 소진",
    PERIOD: "유효기간 만료",
    REFUND: "환불 만료"
};
export var TicketDeductionMethod;
(function(TicketDeductionMethod) {
    TicketDeductionMethod["COUNT"] = "count";
    TicketDeductionMethod["AMOUNT"] = "amount";
})(TicketDeductionMethod || (TicketDeductionMethod = {}));
export var UnUsableReason;
(function(UnUsableReason) {
    UnUsableReason["SUBJECT"] = "이용가능 과목 조건 불일치";
    UnUsableReason["PUBLISHER"] = "이용가능 출판사 조건 불일치";
    UnUsableReason["CURRICULUM"] = "이용가능 교육과정 조건 불일치";
    UnUsableReason["AUTHOR"] = "이용가능 저자 조건 불일치";
    UnUsableReason["PRODUCT_TYPE"] = "이용가능 상품 유형 조건 불일치";
    UnUsableReason["PRICE"] = "이용가능 가격 조건 불일치";
})(UnUsableReason || (UnUsableReason = {}));
export const postMembershipLog = async (params)=>{
    const { data  } = await otherApiClient.market.post("/membership-use-logs", {
        ...params
    });
    return data;
};
export const getPassProducts = async (params)=>{
    const { data  } = await otherApiClient.market("/memberships/products".concat(toQueryStringCamel(params)));
    return data;
};
export const getPassOneProduct = async (id)=>{
    const { data  } = await otherApiClient.market("/memberships/products/".concat(id));
    return data;
};
export const getMemberships = async (params)=>{
    const { data  } = await otherApiClient.market.get("/memberships", {
        params
    });
    return data;
};
export const patchAddPass = async (param)=>{
    const { data  } = await otherApiClient.market.patch("/memberships/tickets", param);
    return data;
};
export const postMembershipSubscribe = async (params)=>{
    const { data  } = await otherApiClient.market.post("/memberships/subscription", params);
    return data;
};
export const getCancelMembership = async ()=>{
    const { data  } = await otherApiClient.market.get("/memberships/subscription/cancel");
    return data;
};
export const getPassMainProducts = async (params)=>{
    const { data  } = await otherApiClient.market("/main/products".concat(toQueryStringCamel(params)));
    return data;
};
// 업셀링 목록 조회 (Plan 메타데이터만, items 미포함)
export const getPlans = async ()=>{
    const { data  } = await otherApiClient.market("/plans");
    return data;
};
// 업셀링 상세 조회 (Plan 메타 + PlanItem 포함)
export const getPlanDetail = async (planId)=>{
    const { data  } = await otherApiClient.market("/plans/".concat(planId));
    return data;
};
